import { useState, useEffect } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Box,
  Button
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { getCountry } from '../../../apis/resturants-winerise';
import { API } from "../../../apis/constants";
import { Toast } from '../../../components/alert';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const LocationsPage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [locationToDelete, setLocationToDelete] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const handleMenuClick = (event, id) => {
    event.stopPropagation(); // prevent card click
    setAnchorEl(event.currentTarget);
    setSelectedId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedId(null);
  };



  const handleOpenModal = (id) => {
    setLocationToDelete(id);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setLocationToDelete(null);
  };

  const confirmDeleteLocation = () => {
    handleDeleteLocation(locationToDelete);
    handleCloseModal();

  };
  const handleOptions = (option, id, name) => {
    if (option.name === 'Edit') {
      navigate(`/restaurant-locations/${id}`);
    } else if (option.name === 'Delete') {
      handleOpenModal(id);
    } else {
      navigate(`/resturant-wineries/${id}?name=${encodeURIComponent(name)}`);
    }
  };

  const handleDeleteLocation = async (id) => {
    let data = await getCountry(`/api/dine/country/${id}`, 'DELETE', { '_method': 'DELETE' })

    Toast('success', data.message);
    await fetchCountries();
  };

  const menuOptions = [
    { name: 'Edit', icon: <ModeEditIcon sx={{ marginLeft: 2 }} /> },
    { name: 'Delete', icon: <DeleteIcon sx={{ marginLeft: 2 }} /> }
  ];
  const [countries, setCountries] = useState([]);
  const navigate = useNavigate();
  async function fetchCountries() {

    try {
      setLoading(true)
      const response = await getCountry('/api/dine/country', 'GET');
      setCountries(response);
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
    setLoading(false)
  }
  useEffect(() => {
    fetchCountries();
  }, [])
  return (
    <Box sx={{ padding: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
        <Typography variant="h4" fontWeight="bold">Restaurant Locations</Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#C84B96',
            color: '#fff',
            borderRadius: 2,
            textTransform: 'capitalize',
            '&:hover': {
              backgroundColor: '#9B3A73', // Darker shade of the current color
            },
          }}

          onClick={() => navigate("/restaurant-locations/new")}
        >
          + Create New Location
        </Button>
      </Box>
      <Grid container spacing={3}>
        {countries.length > 0 ? countries.map((location) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={location.id}
          >
            <Card sx={{ position: 'relative', marginBottom: 2, boxShadow: 3 }}>
              <IconButton
                onClick={(e) => handleMenuClick(e, location.id)}
                sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
              >
                <MoreVertIcon />
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl) && selectedId === location.id}
                onClose={handleMenuClose}
              >
                {menuOptions.map((option, idx) => (
                  <MenuItem
                    key={idx}
                    onClick={() => {
                      handleOptions(option, location.id, location.name);
                      handleMenuClose();
                    }}
                  >
                    {option.icon}
                    <Typography sx={{ marginLeft: 1 }}>{option.name}</Typography>
                  </MenuItem>
                ))}
              </Menu>

              <CardContent sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}

                onClick={(e) => {
                  handleOptions('', location.id, location.name);
                }}
              >
                {location.icon ? (
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      overflow: 'hidden',
                      marginRight: 2
                    }}
                  >
                    <img
                      src={API.baseUrl + location.icon}
                      alt={location.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      backgroundColor: 'primary.main',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: 2,
                      fontSize: 18,
                      fontWeight: 'bold'
                    }}
                  >
                    {location.name.charAt(0).toUpperCase()}
                  </Box>
                )}
                <Box>
                  <Typography variant="h6" fontWeight="bold">{location.name}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {location.description}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )) : (
          loading ? (
            (
              Array.from(new Array(6)).map((_, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card sx={{ marginBottom: 2, boxShadow: 1 }}></Card>
                  <Card sx={{ marginBottom: 2 }}>
                    <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box
                        sx={{
                          width: 50,
                          height: 50,
                          borderRadius: '50%',
                          backgroundColor: 'grey.300',
                          marginRight: 2,
                        }}
                      />
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" sx={{ backgroundColor: 'grey.300', height: 20, marginBottom: 1 }} />
                        <Typography variant="body2" sx={{ backgroundColor: 'grey.300', height: 15, width: '80%' }} />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            )
          ) : (
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '200px',
              }}
            >
              <Typography variant="h6" component="h6">
                No Location FOUND
              </Typography>
            </Grid>
          )
        )
        }
      </Grid>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You want to delete the location.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDeleteLocation} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default LocationsPage;
